<template>
  <generic-view
    :title="$t('pensum distribution')"
    icon="tasks"
    v-bind:show_plus="true"
    v-bind:scrolling="true"
    v-on:add="add"
  >
    <div class="ui list">
      <div class="item" v-for="(course, index) in courses" v-bind:key="index">
        <i class="large cube middle aligned icon"></i>
        <div class="content">
          <div class="description">
            <div class="ui form">
              <div class="fields">
                <div class="seven column wide field">
                  <label v-if="index == 0">{{ $t("course") }}</label>
                  <div
                    class="ui search"
                    ref="course_search"
                    :data-i="index"
                    v-if="!course.crs.uuid"
                  >
                    <div class="ui icon input">
                      <input
                        class="prompt"
                        type="text"
                        :placeholder="$t('search course')"
                        :value="course.crs.name"
                      />
                      <i class="search icon"></i>
                    </div>
                    <div class="results"></div>
                  </div>
                  <div v-if="course.crs.uuid">
                    {{ course.crs.name }}
                  </div>
                </div>
                <div class="seven column wide field">
                  <label v-if="index == 0">{{ $t("study time") }}</label>
                  <div
                    class="ui selection dropdown"
                    ref="study_cycle_dropdown"
                    :data-i="index"
                  >
                    <input type="hidden" name="pet" />
                    <i class="dropdown icon"></i>
                    <div class="default text">{{ $t("study cycle") }}</div>
                    <div class="scrollhint menu"></div>
                  </div>
                </div>
                <div class="seven column wide field">
                  <label class v-if="index == 0">{{ $t("options") }}</label>
                  <div class="ui tiny left floated buttons">
                    <div
                      class="ui basic icon labeled button"
                      v-on:click="remove(course, index)"
                    >
                      <i class="red trash icon"></i>
                      {{ $t("delete") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </generic-view>
</template>

<script>
import { init_search, local_api, error_toast } from "@/utils";
import GenericView from "@/components/GenericContainer";
// import { cloneDeep } from "lodash";

export default {
  name: "PensuModalDistribution",
  props: {},
  components: {
    "generic-view": GenericView,
  },
  data() {
    return {
      courses: [],
      studying_cycle: [],
    };
  },
  methods: {
    add() {
      let vm = this;
      vm.courses.push({ crs: {}, stdy: undefined });
    },
    remove(course, index) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove course?"),
        function () {
          vm.courses.splice(index, 1);
        }
      );
    },
    getList() {
      return this.courses.map((course) => {
        course.crs = course.crs.course_id;
        return course;
      });
    },
    clear() {
      this.courses = [];
    },
    setDistribution(distribution) {
      let vm = this;
      console.log("dkistribution received", distribution);
      let arrResp = distribution.map((i) => {
        return {
          crs: i.crs_course,
          stdy: i.studying_cycle_id,
        };
      });

      this.courses = arrResp;

      setTimeout(() => {
        window.jQuery(vm.$refs.study_cycle_dropdown).map((index, element) => {
          window.jQuery(element).dropdown("set selected", arrResp[index].stdy);
        });
      }, 1000);
    },
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/pensum/do-get-studying-cycle")
      .then((studyingCycles) => {
        vm.studying_cycle = studyingCycles;
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  mounted() {
    let vm = this;
    if (vm.courses_in) {
      vm.courses = vm.courses_in;
    }
  },
  watch: {
    courses() {
      let vm = this;
      setTimeout(() => {
        let onSearchSelect = function (data) {
          let idx = window.jQuery(this).data("i");
          vm.courses[idx].crs = data.course;
        };
        let onSearchResponse = (data) => {
          let rslt = [];
          data.map((r) => {
            rslt.push({
              title: r.name,
              description: r.name,
              course: r,
            });
          });
          return { results: rslt };
        };

        init_search(
          vm,
          vm.$refs.course_search,
          "search course",
          onSearchResponse,
          onSearchSelect
        );

        let vls = vm.studying_cycle.map((i) => {
          return { value: i.studying_cycle_id, name: i.name, stx: i };
        });
        window
          .jQuery(vm.$refs.study_cycle_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value, text, $element) {
              let i = window.jQuery($element).parent().parent().data("i");
              vm.courses[i].stdy = value;
            },
          });
      }, 200);
    },
  },
};
</script>
